import React, { useState } from "react";
import {
  Box,
  Container,
  Button,
  Grid,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Autocomplete,
} from "@mui/material";
import CustomizeInputField from "../CustomizeInputField";
import MultiSelectField from "../../CommonComponents/MultiSelectField";
import {
  CustomAutoComplete,
  CustomInputField,
  CustomTextArea,
} from "../../CommonComponents/CustomCompontes";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import TopViewNav from "../../CommonComponents/TopViewNav";
import { MultiSelect } from "react-multi-select-component";
import { companyWiseEmp } from "../../../actions/Companywiseclient";

const getInputDefaultVal = (type) => {
  if (
    type === "Text" ||
    type === "Email" ||
    type === "TextArea" ||
    type === "Option" ||
    type === "Date"
  ) {
    return "";
  } else if (type === "MultiSelect") {
    return [];
  } else if (type === "File" || type === "Image") {
    return "";
  } else if (type === "Checkbox") {
    return false;
  } else {
    return "";
  }
};

const Preview = () => {
  // const {
  //   data: leadSource = {
  //     data: [],
  //   },
  // } = useGetLeadSourceQuery();
  // const { data: contactOwner = [] } = useGetContactOwnerQuery();

  //  const [previews, setPreviews] = React.useState([]);
  const [formData, setFormData] = React.useState([]);
  const [ClientStatusList, setClientStatusList] = useState([])

  //const previews = useSelector((state) => state.preview.previewLayout);
  const previews = localStorage.getItem("llayout")
    ? JSON.parse(localStorage.getItem("llayout"))
    : [];
  const handleSubmit = (event) => {
    event.preventDefault();
    console.log(formData);
  };
  const fetchPreviewData = () => {
    const formDataToSet = [];
    previews.forEach((preview) => {
      preview.children.column1.forEach((child) => {
        // formDataToSet[child.name]=getInputDefaultVal(child.compName);
        formDataToSet.push({
          label: child.label,
          value: getInputDefaultVal(child.compName),
          name: child.name,
        });
      });
      preview.children.column2.forEach((child) => {
        // formDataToSet[child.name]=getInputDefaultVal(child.compName);
        formDataToSet.push({
          label: child.label,
          value: getInputDefaultVal(child.compName),
          name: child.name,
        });
      });
    });
    // setPreviews(previewData);
    setFormData(formDataToSet);
  };

  const handleChange = (e, type, name) => {
    if (type === "MultiSelect") {
      // setFormData((prevData)=>{return {...prevData, [name]: e}});
      const formDataToSet = formData.map((item) => {
        if (item.name === name) {
          item.value = e;
        }
        return item;
      });
      setFormData(formDataToSet);
    } else if (type === "Checkbox") {
      //  setFormData((prevData)=>{return {...prevData, [e.target.name]: e.target.checked}});
      const formDataToSet = formData.map((item) => {
        if (item.name === name) {
          item.value = e.target.checked;
        }
        return item;
      });
      setFormData(formDataToSet);
    } else {
      //  setFormData((prevData)=>{return {...prevData, [e.target.name]: e.target.value}})
      const formDataToSet = formData.map((item) => {
        if (item.name === name) {
          item.value = e.target.value;
        }
        return item;
      });
      setFormData(formDataToSet);
    }
  };
  const fetchcompanyclientstatusDataList = () => {
    const companyId = JSON.parse(localStorage.getItem("CompanyIdSelect")) && JSON.parse(localStorage.getItem("CompanyIdSelect")).id
    const data =
    {
        hrmsCompanyId: companyId && companyId ? companyId : null,
    }
    companyWiseEmp.fetchcompanyclientstatusmaster(data).then((response) => {
        if (response !== null) {
            setClientStatusList(response.data)

            if (response.responseCode === 404) {
                setClientStatusList([])
                //alert("No record found Status List!!")
                // setClientStatusList(true)

            }
        }
        else {
            setClientStatusList([])
        }
    })

}

  React.useEffect(() => {
    fetchPreviewData();
    fetchcompanyclientstatusDataList()
  }, []);

  const topViewNavData = {
    title: "Preview Dynamice Form",
    backPathRoute: "/dashboard",
  };

  return (
    <div className="contents__root" style={{ marginTop: "10px" }}>
      <Box className="main">
        <Grid item xs={12}>
          <TopViewNav topViewNavData={topViewNavData} />
        </Grid>

        {previews.map(({ layoutName, id, children }, index) => {
          return (
            <Accordion
              className="main_accoardian"
              defaultExpanded={true}
              key={index}
            >
              <AccordionSummary
                className="accordianHeader"
                expandIcon={
                  <AddCircleIcon fontSize="large" style={{ color: "white" }} />
                }
                aria-controls="panel1a-content"
                style={{
                  background: "rgb(10 166 141)",
                  borderRadius: "10px 10px 0px 0px",
                  overflow: "hidden",
                }}
              >
                <Typography
                  style={{
                    color: "#fff",
                    marginLeft: "10px",
                    padding: "10px 2px",
                  }}
                >
                  {layoutName}
                </Typography>
              </AccordionSummary>
              <AccordionDetails
                className="accoardian_body"
                style={{ width: "98%", margin: "auto", marginTop: "10px" }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    {children.column1.map(
                      (
                        {
                          id,
                          name,
                          inputType,
                          compName,
                          label,
                          options,
                          uid,
                          isHidden,
                          mandetoryName,
                          isRequired,
                        },
                        index
                      ) => {
                        return (
                          <React.Fragment key={uid}>
                            {!isHidden ? (
                              <InputComps
                                name={name}
                                compName={compName}
                                label={label}
                                optionss={options}
                                uid={uid}
                                mandetoryName={mandetoryName}
                                leadSource={[]}
                                contactOwner={[]}
                                isRequired={isRequired}
                                ClientStatusList={ClientStatusList}
                              />
                            ) : null}
                          </React.Fragment>
                        );
                      }
                    )}
                  </Grid>
                  <Grid item xs={6}>
                    {children.column2.map(
                      (
                        {
                          id,
                          name,
                          inputType,
                          compName,
                          label,
                          options,
                          uid,
                          isHidden,
                          mandetoryName,
                          isRequired,
                        },
                        index
                      ) => {
                        return (
                          <React.Fragment key={uid}>
                            {!isHidden ? (
                              <InputComps
                                name={name}
                                compName={compName}
                                label={label}
                                optionss={options}
                                uid={uid}
                                mandetoryName={mandetoryName}
                                leadSource={[]}
                                contactOwner={[]}
                                isRequired={isRequired}
                              />
                            ) : null}
                          </React.Fragment>
                        );
                      }
                    )}
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>
          );
        })}
      </Box>
    </div>
  );
};

function InputComps({
  uid,
  label,
  name,
  compName,
  optionss,
  mandetoryName,
  leadSource,
  contactOwner,
  isRequired,
  ClientStatusList
}) {
  let options = optionss;
  if (mandetoryName === "leadSourceName") {
    options = leadSource.map((source) => source.name);
  } else if (mandetoryName === "contactOwnerName") {
    options = contactOwner.map((owner) => `${owner.name}(${owner.email})`);
  }
  else if (mandetoryName === "ClientStatus") {
    options = ClientStatusList && ClientStatusList.map((owner) => `${owner && owner.statusName}`);
}
  const [selected, setSelected] = React.useState([]);
  const multiSelectOptions = [];
  if (options && compName === "MultiSelect") {
    options.forEach((option) => {
      multiSelectOptions.push({
        label: option,
        value: option,
      });
    });
  }

  const renderInputs = () => {
    if (compName === "Text") {
      return (
        <div className="form-group" key={uid}>
          <label htmlFor={name}>{label}</label>
          <CustomInputField
            sx={{ width: "100%", margin: "0px !important" }}
            variant="outlined"
            size="small"
            type="text"
            className="form-control"
            id={name}
            placeholder={label}
            name={name}
            required={isRequired}
          />
        </div>
      );
    } else if (compName === "TextArea") {
      return (
        <div className="form-group shadow-textarea" key={uid}>
          <label htmlFor={name}>{label}</label>
          <CustomTextArea
            multiline
            style={{ resize: "none" }}
            maxRows={5}
            sx={{ width: "100%", margin: "0px !important" }}
            className="form-control z-depth-1"
            id={name}
            placeholder={label}
            name={name}
            required={isRequired}
          />
        </div>
      );
    } else if (compName === "File") {
      return (
        <div className="form-group" key={uid}>
          <label htmlFor={name}>{label}</label>
          <CustomInputField
            type="file"
            sx={{ width: "100%", margin: "0px !important" }}
            className="form-control"
            id={name}
            placeholder={label}
            name={name}
            required={isRequired}
          />
        </div>
      );
    } else if (compName === "Option") {
      return (
        <div className="form-group" key={uid}>
          <label htmlFor={name}>{label}</label>
          <div
            style={{
              display: "flex",
              gap: "10px",
              flexWrap: "wrap",
              padding: "8px 6px",
              background: "#EFF0F2",
              borderRadius: "8px",
              borderLeft: isRequired
                ? "2px solid red"
                : "2px solid transparent",
            }}
          >
            {options.map((option, index) => {
              return (
                <div className="form-check" key={option}>
                  <input
                    className="form-check-input"
                    type="radio"
                    name={name}
                    id={name}
                    required={isRequired}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="flexRadioDefault1"
                  >
                    {option}
                  </label>
                </div>
              );
            })}
          </div>
        </div>
      );
    } else if (compName === "Email") {
      return (
        <div className="form-group" key={uid}>
          <label htmlFor={name}>{label}</label>
          <CustomInputField
            sx={{ width: "100%", margin: "0px !important" }}
            type="email"
            className="form-control"
            id={name}
            placeholder={label}
            name={name}
            variant="outlined"
            required={isRequired}
          />
        </div>
      );
    } else if (compName === "Date" || compName === "date") {
      return (
        <div className="form-group" key={uid}>
          <label htmlFor={name}>{label}</label>
          <CustomInputField
            sx={{ width: "100%", margin: "0px !important" }}
            type="date"
            className="form-control"
            id={name}
            placeholder={label}
            name={name}
            variant="outlined"
            required={isRequired}
          />
        </div>
      );
    } else if (compName === "Checkbox") {
      return (
        <div className="form-check mt-3 mb-3">
          <label htmlFor="flexCheckDefault">{label}</label>
          <div
            sx={{ width: "100%", margin: "0px !important", background: "red" }}
          >
            <CustomInputField
              sx={{
                ".MuiInputBase-root": {
                  borderRadius: "5px !important",
                  padding: "0px 4px",
                  borderLeft: isRequired
                    ? "2px solid red"
                    : "2px solid transparent",
                },
              }}
              className="form-check-input"
              type="checkbox"
              id="flexCheckDefault"
              name={name}
              required={isRequired}
            />
          </div>
        </div>
      );
    } else if (compName === "MultiSelect") {
      return (
        <div className="form-group" key={uid}>
          <label htmlFor={name}>{label}</label>
          <MultiSelect
            options={multiSelectOptions}
            id={name}
            value={selected}
            onChange={setSelected}
          />
        </div>
      );
    } else if (compName === "Select") {
      return (
        <div className="form-group" key={uid}>
          <label htmlFor={name}>{label}</label>
          <CustomAutoComplete
            id={name}
            options={options}
            sx={{
              ".MuiInputBase-root": {
                borderRadius: "5px !important",
                borderLeft: isRequired
                  ? "2px solid red"
                  : "2px solid transparent",
              },
            }}
            renderInput={(params) => (
              <CustomInputField {...params} placeholder={label} />
            )}
          />
        </div>
      );
    } else {
      return <>{label}</>;
    }
  };
  return <React.Fragment>{renderInputs()}</React.Fragment>;
}

var previewData = [
  {
    id: 1,
    isExisting: true,
    layoutName: "Lead Information",
    children: {
      column1: [
        {
          uid: 1,
          id: 1,
          label: "First Name",
          inputType: "text",
          name: "FirstName",
          compName: "Text",
          component: "input",
          isExisting: true,
        },
      ],
      column2: [
        {
          uid: 2,
          id: 1,
          label: "Last Name",
          inputType: "text",
          name: "LastName",
          compName: "Text",
          component: "input",
          isExisting: true,
        },
      ],
    },
  },
  {
    id: 1675248169723,
    isExisting: true,
    layoutName: "New Layout",
    children: {
      column1: [
        {
          id: 2,
          name: "TextArea",
          inputType: "text",
          component: "input",
          label: "TextArea",
          compName: "TextArea",
          isExisting: true,
          uid: "bd851226-3dca-4a77-b395-d6aa6069c9e5",
        },
        {
          id: 3,
          name: "Email",
          inputType: "email",
          component: "input",
          label: "Email",
          compName: "Email",
          isExisting: true,
          uid: "8136b5e1-9701-41d1-a2cc-57c3520eddd5",
        },
        {
          id: 6,
          name: "File",
          inputType: "file",
          component: "input",
          label: "File",
          compName: "File",
          isExisting: true,
          uid: "fa5b2027-a212-4598-975b-c93b4947544f",
        },
      ],
      column2: [
        {
          id: 4,
          name: "checkbox",
          inputType: "checkbox",
          component: "input",
          label: "Checkbox",
          compName: "Checkbox",
          isExisting: true,
          uid: "a37be4a2-825f-4fe4-85f4-3ac9d3bb285a",
        },
        {
          id: 7,
          name: "Gender",
          inputType: "option",
          component: "input",
          label: "Gender",
          compName: "Option",
          isExisting: true,
          uid: "b24e80b4-eefd-402a-a2a4-78e4ce56bb92",
          options: ["Male", "Female", "Other"],
        },
        {
          id: 5,
          name: "MultiSelect",
          inputType: "multiselect",
          component: "input",
          label: "MultiSelect",
          compName: "MultiSelect",
          options: ["Option 1", "Option 2"],
          isExisting: true,
          uid: "a56a4cd7-544b-442a-be8a-c16d0186ed31",
        },
      ],
    },
  },
];

export default Preview;
